<script>
    import _ from "lodash";

    export default {
        data() {
            return {
                muscleLevel: [
                    {
                        is: function (x) {
                            return _.inRange(x, 0, 69);
                        },
                        msg: 'Дезадаптация утомления',
                        variant: 'danger',
                        rate: 1
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 69, 77);
                        },
                        msg: 'Стресс-утомление',
                        variant: 'danger',
                        rate: 2
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 77, 85);
                        },
                        msg: 'Утомление',
                        variant: 'primary',
                        rate: 3
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 85, 93);
                        },
                        msg: 'Хорошее состояние',
                        variant: 'warning',
                        rate: 4
                    },
                    {
                        is: function (x) {
                            return Math.abs(x) > 92;
                        },
                        msg: 'Отличное состояние',
                        variant: 'success',
                        rate: 5
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 88, 93);
                        },
                        msg: 'Хорошее состояние',
                        variant: 'warning',
                        rate: 4
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 83, 88);
                        },
                        msg: 'Возрастающее напряжение',
                        variant: 'warning',
                        rate: 3
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 73, 83);
                        },
                        msg: 'Стресс-резонанс',
                        variant: 'primary',
                        rate: 2
                    },
                    {
                        is: function (x) {
                            return Math.abs(x) < 73;
                        },
                        msg: 'Дезадаптация напряжения',
                        variant: 'danger',
                        rate: 1
                    }
                ],
                sopMuscleLevel: [
                    {
                        is: function (x) {
                            return _.inRange(x, 0, 69);
                        },
                        msg: 'Дезадаптационный дистресс',
                        variant: 'danger',
                        rate: 1
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 69, 77);
                        },
                        msg: 'Выраженная недостаточность',
                        variant: 'danger',
                        rate: 2
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 77, 85);
                        },
                        msg: 'Умеренная недостаточность',
                        variant: 'primary',
                        rate: 3
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 85, 93);
                        },
                        msg: 'Хорошее состояние',
                        variant: 'warning',
                        rate: 4
                    },
                    {
                        is: function (x) {
                            return Math.abs(x) > 92;
                        },
                        msg: 'Отличное состояние',
                        variant: 'success',
                        rate: 5
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 88, 93);
                        },
                        msg: 'Хорошее состояние',
                        variant: 'warning',
                        rate: 4
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 83, 88);
                        },
                        msg: 'Умеренное истощение',
                        variant: 'warning',
                        rate: 3
                    },
                    {
                        is: function (x) {
                            return _.inRange(Math.abs(x), 73, 83);
                        },
                        msg: 'Стресс-истощение',
                        variant: 'primary',
                        rate: 2
                    },
                    {
                        is: function (x) {
                            return Math.abs(x) < 73;
                        },
                        msg: 'Дезадаптация истощения',
                        variant: 'danger',
                        rate: 1
                    }
                ],
                baseTestTraining: [
                    {
                        is: function (kyad, ksd, sop, odv) {
                            return (kyad === 1 && ksd === 1 && sop === 1 && odv >= 67);
                        },
                        msg: 'Тренировки по программе ЛФК',
                        variant: 'danger'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 1 && ksd === 1 && sop === 1);
                        },
                        msg: 'Для рекреации выносливости возможна короткоинтервальная восстановительная тренировка крайне малой мощности <nobr>(типа 3-5×150-200 м)</nobr>',
                        variant: 'primary'
                    },

                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 5 && ksd === 5 && sop === 5);
                        },
                        msg: 'Для развития выносливости показана среднеинтервальная темповая тренировка <nobr>(типа 6-8×800-1200 м)</nobr>',
                        variant: 'success'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 5 && sop === 5);
                        },
                        msg: 'Для развития выносливости показана длинноинтервальная темповая тренировка <nobr>(типа 3-4×2000-2600 м)</nobr>',
                        variant: 'success'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (ksd === 5 && sop === 5);
                        },
                        msg: 'Для развития выносливости показана среднеинтервальная интенсивная тренировка <nobr>(типа 4-6×800-1200 м)</nobr>',
                        variant: 'success'
                    },
                    {
                        is: function (kyad, ksd) {
                            return (kyad === 5 && ksd === 5);
                        },
                        msg: 'Для развития выносливости показана темповая непрерывная продолжительная циклическая тренировка <nobr>(кросс 10-12 км)</nobr>',
                        variant: 'success'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return sop === 5;
                        },
                        msg: 'Для развития выносливости показана короткоинтервальная интенсивная тренировка <nobr>(типа 6-8×200-400 м)</nobr>',
                        variant: 'success'
                    },
                    {
                        is: function (kyad) {
                            return kyad === 5;
                        },
                        msg: 'Для развития выносливости показана аэробная тренировка максимальной мощности',
                        variant: 'success'
                    },
                    {
                        is: function (kyad, ksd) {
                            return ksd === 5;
                        },
                        msg: 'Для развития выносливости показана анаэробная тренировка максимальной мощности',
                        variant: 'success'
                    },

                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 4 && ksd === 4 && sop === 4);
                        },
                        msg: 'Для сохранения выносливости показана среднеинтервальная экстенсивная тренировка <nobr>(типа 3-5×500-700 м)</nobr>',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 4 && sop === 4);
                        },
                        msg: 'Для сохранения выносливости показана длинноинтервальная экстенсивная тренировка <nobr>(типа 2-3×1300-1700 м)</nobr>',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (ksd === 4 && sop === 4);
                        },
                        msg: 'Для сохранения выносливости показана среднеинтервальная темповая тренировка <nobr>(типа 3-5×500-700 м)</nobr>',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad, ksd) {
                            return (kyad === 4 && ksd === 4);
                        },
                        msg: 'Для сохранения выносливости показана экстенсивная циклическая тренировка средней продолжительности <nobr>(кросс 6-8 км)</nobr>',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return sop === 4;
                        },
                        msg: 'Для сохранения выносливости показана короткоинтервальная тренировка средней мощности <nobr>(типа 5-6×200-300 м)</nobr>',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad) {
                            return kyad === 4;
                        },
                        msg: 'Для сохранения выносливости показана аэробная тренировка субмаксимальной мощности',
                        variant: 'warning'
                    },
                    {
                        is: function (kyad, ksd) {
                            return ksd === 4;
                        },
                        msg: 'Для сохранения выносливости показана анаэробная тренировка субмаксимальной мощности',
                        variant: 'warning'
                    },

                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 3 && ksd === 3 && sop === 3);
                        },
                        msg: 'Для рекреации выносливости показана короткоинтервальная восстановительная тренировка <nobr>(типа 3-5×200-300 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 3 && sop === 3);
                        },
                        msg: 'Для рекреации выносливости показана длинноинтервальная восстановительная тренировка <nobr>(типа 2-3×1000-1400 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (ksd === 3 && sop === 3);
                        },
                        msg: 'Для рекреации выносливости показана среднеинтервальная экстенсивная тренировка <nobr>(типа 3-5×400-600 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd) {
                            return (kyad === 3 && ksd === 3);
                        },
                        msg: 'Для рекреации выносливости показана восстановительная циклическая тренировка малой продолжительности <nobr>(кросс 4-6 км)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return sop === 3;
                        },
                        msg: 'Для рекреации выносливости показана короткоинтервальная тренировка малой мощности <nobr>(типа 5-6×100-200 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad) {
                            return kyad === 3;
                        },
                        msg: 'Для рекреации выносливости показана аэробная тренировка малой мощности',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd) {
                            return ksd === 3;
                        },
                        msg: 'Для рекреации выносливости показана анаэробная тренировка малой мощности',
                        variant: 'primary'
                    },

                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 2 && ksd === 2 && sop === 2);
                        },
                        msg: 'Для рекреации выносливости показана короткоинтервальная восстановительная тренировка <nobr>(типа 3-5×200-300 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (kyad === 2 && sop === 2);
                        },
                        msg: 'Для рекреации выносливости показана длинноинтервальная восстановительная тренировка <nobr>(типа 2-3×1000-1400 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return (ksd === 2 && sop === 2);
                        },
                        msg: 'Для рекреации выносливости показана среднеинтервальная экстенсивная тренировка <nobr>(типа 3-5×400-600 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd) {
                            return (kyad === 2 && ksd === 2);
                        },
                        msg: 'Для рекреации выносливости показана восстановительная циклическая тренировка малой продолжительности <nobr>(кросс 4-6 км)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd, sop) {
                            return sop === 2;
                        },
                        msg: 'Для рекреации выносливости показана короткоинтервальная тренировка малой мощности <nobr>(типа 5-6×100-200 м)</nobr>',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad) {
                            return kyad === 2;
                        },
                        msg: 'Для рекреации выносливости показана аэробная тренировка малой мощности',
                        variant: 'primary'
                    },
                    {
                        is: function (kyad, ksd) {
                            return ksd === 2;
                        },
                        msg: 'Для рекреации выносливости показана анаэробная тренировка малой мощности',
                        variant: 'primary'
                    }
                ]
            }
        },
    }
</script>